import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <header className="bg-white border-b border-stone-100">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="privacy-back">
            <img src="/yasamaru-64.png" alt="" className="w-8 h-8" />
            <span className="font-heading font-bold text-base text-stone-800">やさまるシフト</span>
          </Link>
          <Link to="/" className="text-xs text-stone-500 hover:text-stone-700 inline-flex items-center gap-1">
            <ArrowLeft className="w-3 h-3" />トップへ戻る
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-heading font-black text-3xl md:text-4xl text-stone-800 tracking-tight">プライバシーポリシー</h1>
        <p className="mt-2 text-xs text-stone-500">最終更新日：2026年2月15日</p>

        <div className="mt-10 space-y-8 text-sm text-stone-700 leading-relaxed">
          <Section title="1. 事業者情報">
            <p>株式会社フレッシュエージェント（以下「当社」といいます。）は、当社が提供するシフト管理サービス「やさまるシフト」（以下「本サービス」といいます。）における、お客様の個人情報を含む利用者情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。</p>
          </Section>

          <Section title="2. 取得する情報">
            <p>当社は、本サービスの提供にあたり、以下の情報を取得します。</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>会社名・店舗名・担当者氏名・メールアドレス・電話番号などの連絡先情報</li>
              <li>業種・店舗数などの事業情報</li>
              <li>本サービス上で入力されるシフト情報・スタッフ情報</li>
              <li>本サービスの利用状況、アクセスログ、Cookie等の技術情報</li>
              <li>決済に必要な情報（クレジットカード情報は Stripe 社が保持し、当社は保持しません）</li>
            </ul>
          </Section>

          <Section title="3. 利用目的">
            <p>取得した情報は、以下の目的で利用します。</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>本サービスの提供・運営・改善のため</li>
              <li>お客様への連絡、サポート対応、お知らせ送信のため</li>
              <li>不正利用の防止、トラブル対応のため</li>
              <li>利用料金の請求、決済のため</li>
              <li>本サービスに関する統計データの作成（個人を特定できない形式に限ります）</li>
            </ul>
          </Section>

          <Section title="4. 第三者提供">
            <p>当社は、法令で認められた場合を除き、お客様の同意なく個人情報を第三者に提供しません。ただし、以下の業務委託先には、本サービスの提供に必要な範囲で情報を提供することがあります。</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>決済代行：Stripe, Inc.</li>
              <li>メール配信：Resend, Inc.</li>
              <li>クラウドインフラ：本サービスを稼働させるホスティング事業者</li>
            </ul>
          </Section>

          <Section title="5. 安全管理措置">
            <p>当社は、お客様の個人情報の漏洩、滅失または毀損の防止その他の安全管理のために必要かつ適切な措置を講じます。具体的には、アクセス権限の制限、通信の暗号化（HTTPS）、定期的なセキュリティレビュー等を実施しています。</p>
          </Section>

          <Section title="6. 個人情報の保有期間">
            <ul className="list-disc pl-5 space-y-1">
              <li>本サービスを契約いただいたお客様の情報は、サービス提供期間中および解約後も法令で定められた期間（請求情報は税法上7年間など）保管します。</li>
            </ul>
          </Section>

          <Section title="7. 個人情報の開示・訂正・削除">
            <p>お客様は、当社の保有する自己の個人情報について、開示・訂正・削除を求めることができます。ご希望の場合は、本サービスのお問い合わせフォームよりご連絡ください。</p>
          </Section>

          <Section title="8. Cookie の利用">
            <p>本サービスは、利便性向上のため Cookie を利用することがあります。Cookie の利用を望まない場合、ブラウザの設定で無効化できますが、一部機能が利用できなくなる可能性があります。</p>
          </Section>

          <Section title="9. ポリシーの変更">
            <p>本ポリシーは、法令の変更や本サービスの内容に応じて改定することがあります。重要な変更がある場合は、本サービス上または登録メールアドレス宛にお知らせします。</p>
          </Section>

          <Section title="10. お問い合わせ">
            <p>本ポリシーまたは個人情報の取扱いに関するお問い合わせは、本サービスのお問い合わせフォームよりお願いいたします。</p>
            <div className="mt-3 bg-white border border-stone-200 rounded-lg p-4 text-xs">
              <p><b>株式会社フレッシュエージェント</b></p>
              <p>本社所在地:東京都足立区</p>
            </div>
          </Section>
        </div>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading font-bold text-lg text-stone-800 mb-2">{title}</h2>
      {children}
    </section>
  );
}
